import type { DateValue } from '@internationalized/date';
import { writable, type Writable } from 'svelte/store';

import type { DateInfos } from './types';
import type { SnowtrexSelection } from './VisibleDates/types';

export type SelectedPrice = {
    originalPrice: number | null;
    rebateAmount: number | null;
    actualPrice: number | null;
};

const emptySelectedPrice = (): SelectedPrice => ({
    originalPrice: null,
    rebateAmount: null,
    actualPrice: null,
});

export const dateValue: Writable<DateValue | undefined> = writable(undefined);

export const selectedPrice: Writable<SelectedPrice> =
    writable(emptySelectedPrice());

export const resetSelectedPrice = () => selectedPrice.set(emptySelectedPrice());

export const snowtrexSelectedPax = writable(2);

export const snowtrexSelectedDuration = writable<number | null>(null);

export const snowtrexPendingSelection = writable<SnowtrexSelection | null>(
    null,
);

export const datesInfos = writable<DateInfos>({
    price: null,
    remainingStock: null, // gir only
    statusName: '', // gir only
    selectedDate: null, // gir only, for fit use dateValue
});

export const isModalOpen = writable(false);
export const modalStep = writable(1);
